import { vservice } from '@niknevis/vue-modules'

@vservice()
export class InputHelper {
  static convertToOptions(data: object): Array<{ label: string, value: string | number }> {
    return Object.entries(data).map(([key, value]) => ({ label: value, value: key }))
  }
}